import RequestAbstract from "../abstract";

export default class MerchantLocationFiles extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/merchant-location-files";
    }
}
